// src/components/AdminLayout.tsx
import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
	Box,
	Drawer,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Toolbar,
	Divider,
	Button,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import GroupIcon from "@mui/icons-material/Group";
import SettingsIcon from "@mui/icons-material/Settings";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import InfoIcon from "@mui/icons-material/Info";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import RateReviewIcon from "@mui/icons-material/RateReview";
import LogoutIcon from "@mui/icons-material/Logout";

const drawerWidth = 240;

const menuItems = [
	{ text: "Projects", icon: <WorkIcon />, path: "/dashboard/projects" },
	{ text: "Team", icon: <GroupIcon />, path: "/dashboard/team" },
	{ text: "Testimonials", icon: <RateReviewIcon />, path: "/dashboard/testimonials" },
	{ text: "About Us", icon: <InfoIcon />, path: "/dashboard/about-us" },
	{ text: "Contact Info", icon: <ContactMailIcon />, path: "/dashboard/contact-info" },
	{ text: "Digital Guide", icon: <LightbulbIcon />, path: "/dashboard/digital-guide" },
];

export default function AdminLayout() {

	const location = useLocation();
	const navigate = useNavigate();

	const handleLogout = () => {
		localStorage.removeItem("token");
		navigate("/login");
	};

	return (
		<Box sx={{ display: "flex" }}>
			<Drawer
				variant="permanent"
				sx={{
					width: drawerWidth,
					flexShrink: 0,
					[`& .MuiDrawer-paper`]: {
						width: drawerWidth,
						boxSizing: "border-box",
						bgcolor: "background.default",
					},
				}}
			>
				<Toolbar />
				<Box sx={{ overflow: "auto", display: "flex", flexDirection: "column", height: "100%" }}>
					<List>
						{menuItems.map((item) => (
							<ListItem key={item.text} disablePadding>
								<ListItemButton
									selected={location.pathname === item.path}
									onClick={() => navigate(item.path)}
								>
									<ListItemIcon>{item.icon}</ListItemIcon>
									<ListItemText primary={item.text} />
								</ListItemButton>
							</ListItem>
						))}
					</List>
					<Box sx={{ flexGrow: 1 }} />
					<Divider />
					<Button
						startIcon={<LogoutIcon />}
						onClick={handleLogout}
						sx={{ m: 2 }}
						variant="outlined"
						color="error"
					>
						Logout
					</Button>
				</Box>
			</Drawer>

			<Box component="main" sx={{ flexGrow: 1, p: 3 }}>
				<Toolbar />
				<Outlet />
			</Box>
		</Box>
	);
}
